import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const UpdateWorkFlowSteps = createAsyncThunk(
  "WorkFlowSteps",
  async (
    flow,

    { rejectWithValue }
  ) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Flow/WorkFlowSteps", {
        flowActionGUID: flow.flowActionGUID,
        appGuid: flow.appGuid,
        subTaskGuid: flow.subTaskGuid,
        taskGuid: flow.taskGuid,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "WorkFlowSteps");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const WorkFlowSteps = createSlice({
  name: "WorkFlowSteps",
  initialState: {
    WorkFlowSteps: {},
    loadingWorkFlowSteps: false,
    errorWorkFlowSteps: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(UpdateWorkFlowSteps.pending, (state, action) => {
        state.loadingWorkFlowSteps = true;
        state.WorkFlowSteps = action.payload;
        state.errorWorkFlowSteps = null;
      })
      .addCase(UpdateWorkFlowSteps.fulfilled, (state, action) => {
        state.loadingWorkFlowSteps = false;
        state.WorkFlowSteps = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateWorkFlowSteps.rejected, (state, action) => {
        state.loadingWorkFlowSteps = false;
        state.errorWorkFlowSteps = action.payload;
      });
  },
});

export default WorkFlowSteps.reducer;
